/* eslint-disable */

/* tslint:disable */

/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType
} from 'axios';
import axios from 'axios';

export interface FilterFilter {
  /** eo:cloud_cover */
  id: string;
  /** 100 */
  max: number;
  /** 0 */
  min: number;
  /** eo:cloud_cover */
  name: string;
  /** Cloud Coverrage */
  title: string;
  /** % */
  unit: string;
}

export interface IndiceIndice {
  description?: string;
  id: string;
  name: string;
  title?: string;
}

export interface ProvidersBand {
  name?: string;
  wavelength?: number;
}

export interface ProvidersGeometry {
  coordinates?: any;
  type?: string;
}

export interface ProvidersItem {
  bands?: ProvidersBand[];
  /** Custom properties */
  boa_offset_applied?: boolean;
  collection_id?: string;
  constellation?: string;
  constellation_id?: string;
  created?: string;
  data_coverage?: number;
  datetime?: string;
  'eo:cloud_cover'?: number;
  geometry?: ProvidersGeometry;
  grid_square?: string;
  gsd?: number;
  instruments?: string[];
  is_accessible?: boolean;
  latitude_band?: string;
  platform?: string;
  preview_url?: string;
  processing_baseline?: string;
  product_id?: string;
  'proj:epsg'?: number;
  'proj:shape'?: number[];
  'proj:transform'?: number[];
  'proj:wkt2'?: string;
  provider?: string;
  sequence?: string;
  stac_url?: string;
  updated?: string;
  utm_zone?: number;
  valid_cloud_cover?: boolean;
  'view:number_of_bands'?: number;
  'view:off_nadir'?: number;
  'view:satellite_look_angle'?: number;
  'view:sun_azimuth'?: number;
  'view:sun_elevation'?: number;
}

export interface SatelliteBand {
  name?: string;
  offset?: number;
  scale?: number;
  wavelength?: number;
}

export interface SatelliteCollection {
  id?: string;
  name?: string;
  preview_url?: string;
  primary?: boolean;
  provider?: string;
  queryables?: string[];
  rescale?: number[];
  url?: string;
}

export interface SatelliteSatellite {
  bands: SatelliteBand[];
  citation: string;
  collections: SatelliteCollection[];
  deprecated: boolean;
  id: string;
  indice_formulas: Record<string, string>;
  name: string;
  rgb_composite: Record<string, string>;
  visual_asset: Record<string, string>;
}

export interface SearchFields {
  include?: string[];
}

export interface SearchFilter {
  /** eo:cloud_cover */
  id?: string;
  /** 100 */
  max?: number;
  /** 0 */
  min?: number;
}

export interface SearchGeometry {
  coordinates: any;
  type: string;
}

export interface SearchQuery {
  /** @example "2023-05-03T11:56:49.865Z" */
  end_date: string;
  fields?: SearchFields;
  filters?: SearchFilter[];
  geometry: SearchGeometry;
  ids?: string[];
  /** @example 10 */
  limit?: number;
  /** @minItems 1 */
  satellites: SearchSatelliteInfo[];
  /** @example 0 */
  skip?: number;
  /** @example "2023-04-18T11:56:49.865Z" */
  start_date: string;
}

export interface SearchSatelliteInfo {
  /** @example "planetary" */
  collection_id: string;
  /** @example "Landsat-8" */
  satellite_id: string;
}

export interface SearchV2Query {
  /** @example "2023-05-03T11:56:49.865Z" */
  end_date: string;
  fields?: SearchFields;
  filters?: SearchFilter[];
  geometry: SearchGeometry;
  ids?: string[];
  /**
   * @min 1
   * @example 10
   */
  limit?: number;
  satellite: {
    /** @example "planetary" */
    collection_id: string;
    /** @example "Landsat-8" */
    satellite_id: string;
  };
  /**
   * @min 0
   * @example 0
   */
  skip?: number;
  /** @example "2023-04-18T11:56:49.865Z" */
  start_date: string;
}

export interface SearchV2Response {
  items?: Record<string, ProvidersItem>;
  pagination?: {
    limit?: number;
    skip?: number;
    total?: number;
  };
}

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<
  FullRequestParams,
  'body' | 'method' | 'query' | 'path'
>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain'
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || ''
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {})
      }
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] =
        property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem)
        );
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === 'object'
    ) {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (
      type === ContentType.Text &&
      body &&
      body !== null &&
      typeof body !== 'string'
    ) {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { 'Content-Type': type } : {})
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path
    });
  };
}

/**
 * @title Lens API
 * @version 1.0
 * @contact
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * @description Returns a list of all filters available.
     *
     * @tags Filter
     * @name ListFilters
     * @summary List all filters
     * @request GET:/api/v1/filters
     */
    listFilters: (params: RequestParams = {}) =>
      this.request<FilterFilter[], any>({
        path: `/api/v1/filters`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * @description Returns filter details for the given ID.
     *
     * @tags Filter
     * @name GetFilter
     * @summary Get filter by id
     * @request GET:/api/v1/filters/:id
     */
    getFilter: (id: string, params: RequestParams = {}) =>
      this.request<FilterFilter, any>({
        path: `/api/v1/filters/${id}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * @description Returns a list of all indices available.
     *
     * @tags Indice
     * @name ListIndices
     * @summary List all indices
     * @request GET:/api/v1/indices
     */
    listIndices: (params: RequestParams = {}) =>
      this.request<IndiceIndice[], any>({
        path: `/api/v1/indices`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * @description Returns indice details for the given ID.
     *
     * @tags Indice
     * @name GetIndice
     * @summary Get indice by id
     * @request GET:/api/v1/indices/:id
     */
    getIndice: (id: string, params: RequestParams = {}) =>
      this.request<IndiceIndice, any>({
        path: `/api/v1/indices/${id}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * @description Returns a list of all satellites available.
     *
     * @tags Satellite
     * @name ListSatellites
     * @summary List all satellites
     * @request GET:/api/v1/satellites
     */
    listSatellites: (params: RequestParams = {}) =>
      this.request<SatelliteSatellite[], any>({
        path: `/api/v1/satellites`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * @description Returns satellite details for the given ID.
     *
     * @tags Satellite
     * @name GetSatellite
     * @summary Get satellite by id
     * @request GET:/api/v1/satellites/:id
     */
    getSatellite: (id: string, params: RequestParams = {}) =>
      this.request<SatelliteSatellite, any>({
        path: `/api/v1/satellites/${id}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * @description Search for satellite images using the provided query parameters.
     *
     * @tags Search
     * @name SearchV1
     * @summary Search for satellite images
     * @request POST:/api/v1/search
     */
    searchV1: (body: SearchQuery, params: RequestParams = {}) =>
      this.request<Record<string, ProvidersItem>, any>({
        path: `/api/v1/search`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Search for satellite images using the provided query parameters.
     *
     * @tags Search
     * @name SearchV2
     * @summary Search for satellite images
     * @request POST:/api/v2/search
     */
    searchV2: (body: SearchV2Query, params: RequestParams = {}) =>
      this.request<SearchV2Response, any>({
        path: `/api/v2/search`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params
      })
  };
}
